import React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

import styles from './banner-group-component.module.css';

export const BannerGroupLoader: React.FC = () => {
    return (
        <div className={`${styles.card} ${styles['card-loader']}`}>
            <Placeholder className="full-width full-height">
                <Placeholder.Line length="full" />
            </Placeholder>
        </div>
    );
};
